const plug = new Object();
import store from './../store'
import HttpsEncrypt from "@/http/indexencrypt";
import config from '@/utils/config.js'

/************************************************************
 *
 * 时分秒的判断
 *
 ************************************************************/
function formatTen(num) {
    return num > 9 ? num + "" : "0" + num;
}

plug.install = (Vue, options) => {
    Vue.prototype.$api = config

    Vue.mixin({
        components: {
            // 全局组件
            file_preview: re => require(['@/components/Common/file_preview.vue'], re),
            FilePreview: re => require(['@/components/Common/FilePreview'], re),
            MN_Editor: re => require(['@/components/Common/Aqt_MN_Editor'], re),
            CN_Editor: re => require(['@/components/Common/Aqt_CN_Editor'], re),
            AqtTable: re => require(['@/components/Common/AqtTable'], re),
            AqtSidebar: re => require(['@/components/Common/AqtSidebar'], re),
            UploadFiles: re => require(['@/components/Common/UploadFiles'], re),
            //  百度编辑器
            // AqtUeditor: re => require(['@c/AqtUeditor'], re),
            UploadFilesOss: re => require(['@/components/Common/UploadFilesOSS'], re),
            AqtUploadImgOss: re => require(['@/components/Common/AqtUploadImgOSS'], re),
            UploadFilesEncryOss: re => require(['@/components/Common/UploadFilesEncryOSS'], re),
            AqtUploadImgEncryOss: re => require(['@/components/Common/AqtUploadImgEncryOSS'], re),
        },
        computed: {},
        mounted() {
        }

    })
    // 注册转码过滤器 U2M
    Vue.filter('U2M', function (value) {
        if (value) {
            return Unicode2M(value);
        } else {
            return value
        }

    })
    // 注册转码过滤器 M2U
    Vue.filter('M2U', function (value) {
        if (value) {
            return M2Unicode(value);
        } else {
            return value
        }

    })
    Vue.prototype.U2M = function (value) {
        //changeData是函数名
        if (value) {
            var filetered = Unicode2M(value);
        } else {
            var filetered = value;
        }
        return filetered;
    }
    Vue.prototype.M2U = function (value) {
        //changeData是函数名
        if (value) {
            var filetered = M2Unicode(value);
        } else {
            var filetered = value;
        }
        return filetered;
    }
    //根据文件名判断文件类型（用于文件预览功能）
    Vue.prototype.$fileTypeChange = function (name) {
        let file_arr = name.split('?')
        let filename = file_arr && file_arr.length ? file_arr[0] : name

        let d = ''
        try {
            var flieArr = filename.split('.');
            d = flieArr[flieArr.length - 1];
        } catch (err) {
            d = '';
        }
        // let d = /\.[^\.]+$/.exec(name)[0];
        switch (d) {
            //图片格式
            case 'png':
                d = 'image';
                break;
            case 'gif':
                d = 'image';
                break;
            case 'jpg':
                d = 'image';
                break;
            case 'bmp':
                d = 'image';
                break;
            case 'jpeg':
                d = 'image';
                break;
            //视频格式
            case 'ogg':
                d = 'video';
                break;
            case 'mp4':
                d = 'video';
                break;
            case 'webm':
                d = 'video';
                break;
            //音频格式
            case 'mp3':
                d = 'audio';
                break;
            //word格式
            case 'doc':
                d = 'word';
                break;
            case 'docx':
                d = 'word';
                break;
            //excel格式
            case 'xls':
                d = 'excel';
                break;
            case 'xlsx':
                d = 'excel';
                break;
            //ppt格式
            case 'ppt':
                d = 'ppt';
                break;
            case 'pptx':
                d = 'ppt';
                break;
            //pdf格式
            case 'pdf':
                d = 'pdf';
                break;

            default:
                d = 'file';
                break;
        }
        return d
    }

    /************************************************************
     * 文字高亮
     ************************************************************/
    Vue.prototype.$dataLight = function (str, lang, key) {
        if (lang == 'mn') {
            let arr = str.split(" ");
            let strarr = key.split(" ");

            arr.forEach((elem, index) => {
                strarr.forEach((it) => {
                    if (!it) {
                        return str;
                    }
                    let i = elem.indexOf(it.trim());
                    if (i > -1) {
                        let replacestr = `<span style="color:var(--themeColor)!important;">${arr[index]}</span>`
                        arr[index] = replacestr;
                    }
                });

            });

            str = arr.join(" ");
        }
        if (lang == 'zh') {
            if (!str) {
                return str;
            }
            let search = new RegExp(key, 'g');
            let replacestr = `<span style="color:var(--themeColor)!important;">${key}</span>`
            str = str.replace(search, replacestr);
        }
        return str;
    },
    //去掉文件后缀名
    Vue.prototype.$DeleteFileName = function (value) {
            if (value) {
                const noExtension = value.replace(/(.*)\.[^.]+$/, "$1")
                return noExtension
            }
        }
    //将文本中的所有\n’转换成<br>
    Vue.prototype.$TextConversion = function (text) {
        return text.replace(/\n/g, '<br>');
    }
    Vue.prototype.$getNowTime = function () {
        let dateTime = ''
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        dateTime = year + "-" + formatTen(month) + "-" + formatTen(day) + " " + formatTen(hour) + ":" + formatTen(minute) + ":" + formatTen(second)
        return dateTime
    }
    /**
     * 不跳转窗口的情况下下载文件
     *  data 为文件URL
     */
    Vue.prototype.$download = function (data,name) {
        if (!data) {
            return
        }
        const link = document.createElement('a')
        link.download = name?Vue.prototype.$DeleteFileName(name)+Vue.prototype.$getNowTime():'' // 设置下载的文件名
        link.href = data
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

}
export default plug
